import(/* webpackMode: "eager" */ "/var/www/dev-716-cannabis/app/blog/[slug]/page.tsx");
